import { useCallback, useState, RefObject } from 'react';

export function useRefFinally<T>() {
  // See https://reactjs.org/docs/hooks-faq.html#how-can-i-measure-a-dom-node
  // "Using a callback ref ensures that even if a child component displays the measured node later
  // (e.g. in response to a click), we still get notified about it in the parent component
  // and can update the measurements."
  const [refObject, setRefObject] = useState<RefObject<T>>({ current: null });
  const refCallback = useCallback((node: T) => {
    if (node !== null) {
      setRefObject({ current: node });
    }
  }, []);
  return [refCallback, refObject] as const;
}
